import { Component, Input } from '@angular/core';
import { BUTTON_STYLES, ICONS } from '../../../constants/constants';
import { Organization } from '../../../types/organization.type';
import { ROUTES } from '../../../constants/routes';

@Component({
  selector: 'app-organization-empty-event-list',
  templateUrl: './organization-empty-event-list.component.html',
  styleUrls: ['./organization-empty-event-list.component.scss'],
})
export class OrganizationEmptyEventListComponent {
  protected readonly ICONS = ICONS;
  protected readonly BUTTON_STYLES = BUTTON_STYLES;
  protected readonly ROUTES = ROUTES;

  @Input() organization: Organization | undefined;

  get queryParams(): {
    categories: number[];
  } {
    return {
      categories:
        this.organization?.categories.map((cat) => cat.category_id) ?? [],
    };
  }
}
